import script from "./base-office-hour-offering-card.vue?vue&type=script&setup=true&lang=js"
export * from "./base-office-hour-offering-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__